import { render, staticRenderFns } from "./goodsLabelDatas.vue?vue&type=template&id=b5860022&scoped=true&"
import script from "./goodsLabelDatas.vue?vue&type=script&lang=js&"
export * from "./goodsLabelDatas.vue?vue&type=script&lang=js&"
import style0 from "./goodsLabelDatas.vue?vue&type=style&index=0&id=b5860022&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5860022",
  null
  
)

component.options.__file = "goodsLabelDatas.vue"
export default component.exports